export default __webpack_public_path__ + "static/media/tosse.be7a29a5.svg";